// extracted by mini-css-extract-plugin
export default {"container":"container-rAdng","title":"title-j_KCz","subTitle":"subTitle-NXgf5","close":"close-wGZ8G","icon":"icon-HrqG7"};